module.exports = __webpack_public_path__ + "img/1.4ed6c1de.png";